import React from 'react';

import Button from 'components/Buttons/Button';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, ComponentArea, StepsArea, Steps, Circle, Next, HeaderArea } from './styles';

interface Props {
  children?: any;
  stepsProps?: any;
  index: number;
  onJump: () => void;
}

const Stepper = ({ children, stepsProps, index, onJump }: Props) => {
  const { t } = useStoreTranslation();

  const handleNextClick = () => {
    onJump();
  };

  return (
    <Container>
      <HeaderArea />
      <ComponentArea>{children}</ComponentArea>
      <StepsArea>
        <Steps>
          {stepsProps.map((_: any, i: number) => (
            <Circle key={i} styledProps={{ active: i === index }} />
          ))}
        </Steps>
      </StepsArea>
      <Next>
        <Button onClick={handleNextClick}>{t('walkThrough.next')}</Button>
      </Next>
    </Container>
  );
};

export default Stepper;
